import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Chip from "@mui/material/Chip";

const OrderDetails = ({ ...props }) => {
  const [parsedTime, setParsedTime] = useState("");
  const [statusColor, setStatusColor] = useState("info");

  const convertData = (time) => {
    const dateObj = new Date(time);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate = dateObj.toLocaleString("en-US", options);
    setParsedTime(formattedDate);

    const statusColorMap = {
      READY_FOR_REVIEW: "primary",
      DELIVERED: "success",
      DONE: "info",
      DELETE: "error",
    };
    setStatusColor(statusColorMap[props.order.orderStatus] || "info");
  };

  useEffect(() => {
    convertData(props.order.orderDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <Accordion style={{ width: '100%' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography component="div">
            <div style={{ marginBottom: '5px'}}>
              <strong>Date: </strong>
              {parsedTime}
            </div>
            <div style={{ marginBottom: '5px'}}>
              <strong>Status: </strong>
              <Chip
                label={props.order.orderStatus}
                variant="outlined"
                color={statusColor}
              />
            </div>
            <div style={{ marginBottom: '5px'}}>
              <strong>Bill: </strong>
              <Chip
                label={`${props.order.orderPrice.toFixed(2)} CHF` }
                variant="outlined"
                color={"info"}
              />
            </div>
            <div style={{ marginBottom: '5px'}}>
              <strong>Paid: </strong>
              <Chip
                label={props.order.paid ? "Yes" : "Not yet"}
                variant="outlined"
                color={props.order.paid ? "success" : "error"}
              />
            </div>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ paddingLeft: '15px'}} component="div">
            <ul>
              {props.order.productList.map(item => (<li key={item.id}>{item.name}</li>))}
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
  );
};

export default OrderDetails;
